/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowParallelVIcon16Light } from './ArrowParallelVIcon16Light';
import { ArrowParallelVIcon16Regular } from './ArrowParallelVIcon16Regular';
import { ArrowParallelVIcon16Solid } from './ArrowParallelVIcon16Solid';
import { ArrowParallelVIcon20Light } from './ArrowParallelVIcon20Light';
import { ArrowParallelVIcon20Regular } from './ArrowParallelVIcon20Regular';
import { ArrowParallelVIcon20Solid } from './ArrowParallelVIcon20Solid';
import { ArrowParallelVIcon24Regular } from './ArrowParallelVIcon24Regular';
import { ArrowParallelVIcon24Solid } from './ArrowParallelVIcon24Solid';
import { ArrowParallelVIcon32Regular } from './ArrowParallelVIcon32Regular';
import { ArrowParallelVIcon64Regular } from './ArrowParallelVIcon64Regular';
var sizes = {
    16: {
        light: ArrowParallelVIcon16Light,
        regular: ArrowParallelVIcon16Regular,
        solid: ArrowParallelVIcon16Solid,
    },
    20: {
        light: ArrowParallelVIcon20Light,
        regular: ArrowParallelVIcon20Regular,
        solid: ArrowParallelVIcon20Solid,
    },
    24: {
        regular: ArrowParallelVIcon24Regular,
        solid: ArrowParallelVIcon24Solid,
    },
    32: {
        regular: ArrowParallelVIcon32Regular,
    },
    64: {
        regular: ArrowParallelVIcon64Regular,
    },
};
export var ArrowParallelVIcon = forwardRef('ArrowParallelVIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
